import { ScrollArea } from '@ais-ui/ui-core';
import { TargetCard } from '../../modules/Targets/TargetDetails';
import { VesselDashboardLayout } from '../../modules/Targets/TargetDashboard/VesselDashboardLayout';
import { DetailView, useViewMode } from '../ViewModeProvider';
import { Atons } from '../../modules/Atons/Atons';
import { AtonDashboardLayout } from '../../modules/Atons/AtonDashboard/AtonDashboardLayout';
import { DetailAtons } from '../../modules/Atons/DetailAtons'; // Add this import

export const DetailsPage = () => {
  const { detailView } = useViewMode();

  return (
    <div className="w-full h-full p-4 pb-2 pl-0 bg-gradient-to-b from-background to-slate-50">
      <div className="w-full h-full border rounded-lg bg-background shadow">
        <div className="flex h-full space-x-2 mr-4">
          <div className="flex-1 p-8 pt-6 flex flex-col overflow-hidden">
            <ScrollArea
              observeResize={false}
              className="flex-grow p-0 overflow-y-auto"
            >
              {detailView === DetailView.Vessel && (
                <VesselDashboardLayout></VesselDashboardLayout>
              )}
              {detailView === DetailView.Aton && (
                <AtonDashboardLayout></AtonDashboardLayout>
              )}
            </ScrollArea>
          </div>
          <div className="items-center flex">
            {detailView === DetailView.Vessel && (
              <TargetCard className="h-[98%] shadow"></TargetCard>
            )}
            {detailView === DetailView.Aton && (
              <DetailAtons className="h-[98%] w-[384px] shadow"></DetailAtons>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
